module.exports = __webpack_public_path__ + "static/media/mastercard.95fd27a6.png";